import { Component, OnInit, ViewChild } from '@angular/core';
import {FormGroup, FormControl, Validators} from '@angular/forms';
import { CallAPIService } from '../../../services/call-api.service';
import { BehaviorSubject } from 'rxjs';
import {ActivatedRoute} from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
  selector: 'find-address',
  templateUrl: './find-address.component.html',
  styleUrls: ['./find-address.component.sass']
})
export class FindAddressComponent implements OnInit {
  postIndexForm: FormGroup;
  requestForDataPosted = new BehaviorSubject( undefined );
  responseReadySubject = new BehaviorSubject( undefined );

  @ViewChild('autoShownModal', { static: false }) autoShownModal: ModalDirective;
  isModalShown = true;

  showModal(): void {
    this.isModalShown = true;
  }

  hideModal(): void {
    this.autoShownModal.hide();
  }

  onHidden(): void {
    this.isModalShown = false;
  }

  constructor(
    private readonly API: CallAPIService,
    private readonly activatedRoute: ActivatedRoute
  ) {
    this.postIndexForm = new FormGroup({
      postIndex: new FormControl('', [
        Validators.pattern('^[0-9]*$'),
        Validators.minLength(5),
        Validators.maxLength(5)
      ])
    });
  }

  ngOnInit() {
    const postIndexParam = this.activatedRoute.snapshot.queryParams.postIndex;
    if (postIndexParam && !isNaN(postIndexParam)) {
      this.postIndexForm.setValue({
        postIndex: postIndexParam
      });
    }
    this.postIndexForm.controls['postIndex'].setValue(
      postIndexParam
    );

    this.submit();
    const clearConfig = this.API.buildClearConfig( true, true, true, true, true );
    this.API.executeClearWithConfig( clearConfig );
    this.API.getClearSubject().asObservable().subscribe( clear => {

      //this.requestForDataPosted.next( true );

    })

    this.responseReadySubject.asObservable().subscribe( response => {
      if( response ){
        this.scrollTo('responseAddress');
      }
    } )
  }

  submit() {
    if (!this.postIndexForm.valid) {
      return;
    }

    this.API.getStreetsByIndexMakeStreetsObject(this.postIndexForm.value.postIndex);
    this.API.getPostOfficeInfoByIndex(this.postIndexForm.value.postIndex);
  }

  scrollTo( elementID: string ){

    if( window.innerWidth <= 767 ){
      const interval = setTimeout( () => {

        if( document.getElementById( elementID ) ){
          document.getElementById( elementID ).scrollIntoView();
          clearInterval( interval );
        }

      } , 50 ) ;
    }
  }
}
